// src/components/LoadingIndicator.js
import React, { useState, useRef, useEffect } from "react";
import "./LoadingIndicator.css";  // you can copy the CSS from CoachPractice.css

export const Hexagon = ({ className, points, delay }) => {
  const [rotation, setRotation] = useState(0);
  const hexRef = useRef(null);
  const handleIteration = () => setRotation((r) => r + 60);
  useEffect(() => {
    const node = hexRef.current;
    node?.addEventListener("animationiteration", handleIteration);
    return () => node?.removeEventListener("animationiteration", handleIteration);
  }, []);
  return (
    <polygon
      ref={hexRef}
      className={`hex ${className}`}
      points={points}
      style={{ transform: `rotate(${rotation}deg)`, animationDelay:`${delay}ms` }}
    />
  );
};

export default function LoadingIndicator() {
  return (
    <div className="loading-indicator-container">
      <svg width="150" height="320" viewBox="0 0 150 320">
        <Hexagon className="hex1" delay={0}    points="105,50 90,76 60,76 45,50 60,24 90,24" />
        <Hexagon className="hex2" delay={500}  points="135,110 120,136 90,136 75,110 90,84 120,84" />
        <Hexagon className="hex3" delay={1000} points="105,170 90,196 60,196 45,170 60,144 90,144" />
        <Hexagon className="hex4" delay={1500} points="135,230 120,256 90,256 75,230 90,204 120,204" />
        <Hexagon className="hex5" delay={2000} points="105,290 90,316 60,316 45,290 60,264 90,264" />
      </svg>
    </div>
  );
}
